function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as a } from "./index.es33.js";
import { clsx as p } from "./index.es105.js";
import { addInlineStyles as x } from "./index.es143.js";
import e from "./index.es144.js";

var y = function y(_ref) {
  var _p;

  var t = _ref.className,
      r = _ref.children,
      s = _ref.background,
      m = _ref.width,
      l = _ref.height,
      n = _ref.borderRadius,
      i = _ref.isCircle,
      o = _ref.isDarkFlare;
  return a.jsx("div", {
    className: p(e.skeletonLine, t, (_p = {}, _defineProperty(_p, e.normalFlare, !o), _defineProperty(_p, e.darkFlare, o), _p)),
    style: x({
      background: s,
      width: m,
      height: l,
      borderRadius: n,
      isCircle: i
    }),
    children: r
  });
};

export { y as SkeletonLine };